<template>
    <div style="text-align: center;">
        
        <div style="margin-top: 100px;">
            <img class="login-logo" v-if="logo" :src="logo" style="width: 60px" />
            <div style="font-weight: bold; font-size: 18px; padding-top: 10px;">登录确认</div>
        </div>
        <div v-if="loginSuccess" style="padding-top: 200px; font-size: 18px; color: #67C23A;font-weight: bold;">
            登录成功
        </div>
        <div style="position: absolute;bottom: 200px; width: 100%;" v-if="!loginSuccess">
            <el-button type="primary" style="width: 50%;" @click="login()">登录</el-button>
        </div>
    </div>
</template>

<script>
import idaas from "@/apis/idaas";
import logoImg from "@/static/icon_login.png";
export default {
  data() {
    return {
        logo: logoImg,
        loading: true,
        ticket: this.$route.query.ticket,
        loginSuccess: false
    };
  },
  created() {
        
  },
  methods: {
    login() {
        idaas.scanCallback(this.ticket).then((res) => {
            console.log(res);
            this.loginSuccess = true;
        });
    }
  }
};
</script>